'use client';

import Script from 'next/script';

import { GA_MEASUREMENT_ID } from '@/lib/tracking/tracking-ids';
import { useMarketingTagsEnabled } from '@/lib/tracking/use-marketing-tags';

/**
 * GA4 for auth routes (/login, /forgot, /activate, /reset).
 * Live-only; mounts after hydration to avoid SSR/client mismatch.
 */
export function AuthTrackingScripts() {
  const showProdPixels = useMarketingTagsEnabled();

  if (!showProdPixels) {
    return null;
  }

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="afterInteractive"
      />
      <Script id="login-gtag" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          window.gtag = gtag;
          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}');
        `}
      </Script>
    </>
  );
}
